import _defineProperty from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { mergeSort } from '../../../base/common/arrays.js';
import { stringDiff } from '../../../base/common/diff/diff.js';
import { globals } from '../../../base/common/platform.js';
import { URI } from '../../../base/common/uri.js';
import { Position } from '../core/position.js';
import { Range } from '../core/range.js';
import { DiffComputer } from '../diff/diffComputer.js';
import { MirrorTextModel as BaseMirrorModel } from '../model/mirrorTextModel.js';
import { ensureValidWordDefinition, getWordAtText } from '../model/wordHelper.js';
import { computeLinks as _computeLinks } from '../modes/linkComputer.js';
import { BasicInplaceReplace } from '../modes/supports/inplaceReplaceSupport.js';
import { createMonacoBaseAPI } from '../standalone/standaloneBase.js';
import * as types from '../../../base/common/types.js';
/**
 * @internal
 */

var MirrorModel = /*#__PURE__*/function (_BaseMirrorModel) {
  _inherits(MirrorModel, _BaseMirrorModel);

  var _super = _createSuper(MirrorModel);

  function MirrorModel() {
    _classCallCheck(this, MirrorModel);

    return _super.apply(this, arguments);
  }

  _createClass(MirrorModel, [{
    key: "uri",
    get: function get() {
      return this._uri;
    }
  }, {
    key: "version",
    get: function get() {
      return this._versionId;
    }
  }, {
    key: "eol",
    get: function get() {
      return this._eol;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.getText();
    }
  }, {
    key: "getLinesContent",
    value: function getLinesContent() {
      return this._lines.slice(0);
    }
  }, {
    key: "getLineCount",
    value: function getLineCount() {
      return this._lines.length;
    }
  }, {
    key: "getLineContent",
    value: function getLineContent(lineNumber) {
      return this._lines[lineNumber - 1];
    }
  }, {
    key: "getWordAtPosition",
    value: function getWordAtPosition(position, wordDefinition) {
      var wordAtText = getWordAtText(position.column, ensureValidWordDefinition(wordDefinition), this._lines[position.lineNumber - 1], 0);

      if (wordAtText) {
        return new Range(position.lineNumber, wordAtText.startColumn, position.lineNumber, wordAtText.endColumn);
      }

      return null;
    }
  }, {
    key: "words",
    value: function words(wordDefinition) {
      var lines = this._lines;

      var wordenize = this._wordenize.bind(this);

      var lineNumber = 0;
      var lineText = '';
      var wordRangesIdx = 0;
      var wordRanges = [];
      return _defineProperty({}, Symbol.iterator, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!true) {
                  _context.next = 18;
                  break;
                }

                if (!(wordRangesIdx < wordRanges.length)) {
                  _context.next = 8;
                  break;
                }

                value = lineText.substring(wordRanges[wordRangesIdx].start, wordRanges[wordRangesIdx].end);
                wordRangesIdx += 1;
                _context.next = 6;
                return value;

              case 6:
                _context.next = 16;
                break;

              case 8:
                if (!(lineNumber < lines.length)) {
                  _context.next = 15;
                  break;
                }

                lineText = lines[lineNumber];
                wordRanges = wordenize(lineText, wordDefinition);
                wordRangesIdx = 0;
                lineNumber += 1;
                _context.next = 16;
                break;

              case 15:
                return _context.abrupt("break", 18);

              case 16:
                _context.next = 0;
                break;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "getLineWords",
    value: function getLineWords(lineNumber, wordDefinition) {
      var content = this._lines[lineNumber - 1];

      var ranges = this._wordenize(content, wordDefinition);

      var words = [];

      var _iterator = _createForOfIteratorHelper(ranges),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var range = _step.value;
          words.push({
            word: content.substring(range.start, range.end),
            startColumn: range.start + 1,
            endColumn: range.end + 1
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return words;
    }
  }, {
    key: "_wordenize",
    value: function _wordenize(content, wordDefinition) {
      var result = [];
      var match;
      wordDefinition.lastIndex = 0; // reset lastIndex just to be sure

      while (match = wordDefinition.exec(content)) {
        if (match[0].length === 0) {
          // it did match the empty string
          break;
        }

        result.push({
          start: match.index,
          end: match.index + match[0].length
        });
      }

      return result;
    }
  }, {
    key: "getValueInRange",
    value: function getValueInRange(range) {
      range = this._validateRange(range);

      if (range.startLineNumber === range.endLineNumber) {
        return this._lines[range.startLineNumber - 1].substring(range.startColumn - 1, range.endColumn - 1);
      }

      var lineEnding = this._eol;
      var startLineIndex = range.startLineNumber - 1;
      var endLineIndex = range.endLineNumber - 1;
      var resultLines = [];
      resultLines.push(this._lines[startLineIndex].substring(range.startColumn - 1));

      for (var i = startLineIndex + 1; i < endLineIndex; i++) {
        resultLines.push(this._lines[i]);
      }

      resultLines.push(this._lines[endLineIndex].substring(0, range.endColumn - 1));
      return resultLines.join(lineEnding);
    }
  }, {
    key: "offsetAt",
    value: function offsetAt(position) {
      position = this._validatePosition(position);

      this._ensureLineStarts();

      return this._lineStarts.getAccumulatedValue(position.lineNumber - 2) + (position.column - 1);
    }
  }, {
    key: "positionAt",
    value: function positionAt(offset) {
      offset = Math.floor(offset);
      offset = Math.max(0, offset);

      this._ensureLineStarts();

      var out = this._lineStarts.getIndexOf(offset);

      var lineLength = this._lines[out.index].length; // Ensure we return a valid position

      return {
        lineNumber: 1 + out.index,
        column: 1 + Math.min(out.remainder, lineLength)
      };
    }
  }, {
    key: "_validateRange",
    value: function _validateRange(range) {
      var start = this._validatePosition({
        lineNumber: range.startLineNumber,
        column: range.startColumn
      });

      var end = this._validatePosition({
        lineNumber: range.endLineNumber,
        column: range.endColumn
      });

      if (start.lineNumber !== range.startLineNumber || start.column !== range.startColumn || end.lineNumber !== range.endLineNumber || end.column !== range.endColumn) {
        return {
          startLineNumber: start.lineNumber,
          startColumn: start.column,
          endLineNumber: end.lineNumber,
          endColumn: end.column
        };
      }

      return range;
    }
  }, {
    key: "_validatePosition",
    value: function _validatePosition(position) {
      if (!Position.isIPosition(position)) {
        throw new Error('bad position');
      }

      var lineNumber = position.lineNumber,
          column = position.column;
      var hasChanged = false;

      if (lineNumber < 1) {
        lineNumber = 1;
        column = 1;
        hasChanged = true;
      } else if (lineNumber > this._lines.length) {
        lineNumber = this._lines.length;
        column = this._lines[lineNumber - 1].length + 1;
        hasChanged = true;
      } else {
        var maxCharacter = this._lines[lineNumber - 1].length + 1;

        if (column < 1) {
          column = 1;
          hasChanged = true;
        } else if (column > maxCharacter) {
          column = maxCharacter;
          hasChanged = true;
        }
      }

      if (!hasChanged) {
        return position;
      } else {
        return {
          lineNumber: lineNumber,
          column: column
        };
      }
    }
  }]);

  return MirrorModel;
}(BaseMirrorModel);
/**
 * @internal
 */


export var EditorSimpleWorker = /*#__PURE__*/function () {
  function EditorSimpleWorker(host, foreignModuleFactory) {
    _classCallCheck(this, EditorSimpleWorker);

    this._host = host;
    this._models = Object.create(null);
    this._foreignModuleFactory = foreignModuleFactory;
    this._foreignModule = null;
  }

  _createClass(EditorSimpleWorker, [{
    key: "dispose",
    value: function dispose() {
      this._models = Object.create(null);
    }
  }, {
    key: "_getModel",
    value: function _getModel(uri) {
      return this._models[uri];
    }
  }, {
    key: "_getModels",
    value: function _getModels() {
      var _this = this;

      var all = [];
      Object.keys(this._models).forEach(function (key) {
        return all.push(_this._models[key]);
      });
      return all;
    }
  }, {
    key: "acceptNewModel",
    value: function acceptNewModel(data) {
      this._models[data.url] = new MirrorModel(URI.parse(data.url), data.lines, data.EOL, data.versionId);
    }
  }, {
    key: "acceptModelChanged",
    value: function acceptModelChanged(strURL, e) {
      if (!this._models[strURL]) {
        return;
      }

      var model = this._models[strURL];
      model.onEvents(e);
    }
  }, {
    key: "acceptRemovedModel",
    value: function acceptRemovedModel(strURL) {
      if (!this._models[strURL]) {
        return;
      }

      delete this._models[strURL];
    } // ---- BEGIN diff --------------------------------------------------------------------------

  }, {
    key: "computeDiff",
    value: function computeDiff(originalUrl, modifiedUrl, ignoreTrimWhitespace, maxComputationTime) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var original, modified, originalLines, modifiedLines, diffComputer, diffResult, identical;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                original = this._getModel(originalUrl);
                modified = this._getModel(modifiedUrl);

                if (!(!original || !modified)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", null);

              case 4:
                originalLines = original.getLinesContent();
                modifiedLines = modified.getLinesContent();
                diffComputer = new DiffComputer(originalLines, modifiedLines, {
                  shouldComputeCharChanges: true,
                  shouldPostProcessCharChanges: true,
                  shouldIgnoreTrimWhitespace: ignoreTrimWhitespace,
                  shouldMakePrettyDiff: true,
                  maxComputationTime: maxComputationTime
                });
                diffResult = diffComputer.computeDiff();
                identical = diffResult.changes.length > 0 ? false : this._modelsAreIdentical(original, modified);
                return _context2.abrupt("return", {
                  quitEarly: diffResult.quitEarly,
                  identical: identical,
                  changes: diffResult.changes
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "_modelsAreIdentical",
    value: function _modelsAreIdentical(original, modified) {
      var originalLineCount = original.getLineCount();
      var modifiedLineCount = modified.getLineCount();

      if (originalLineCount !== modifiedLineCount) {
        return false;
      }

      for (var line = 1; line <= originalLineCount; line++) {
        var originalLine = original.getLineContent(line);
        var modifiedLine = modified.getLineContent(line);

        if (originalLine !== modifiedLine) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "computeMoreMinimalEdits",
    value: function computeMoreMinimalEdits(modelUrl, edits) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var model, result, lastEol, _iterator2, _step2, _step2$value, range, text, eol, original, changes, editOffset, _iterator3, _step3, change, start, end, newEdit;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                model = this._getModel(modelUrl);

                if (model) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", edits);

              case 3:
                result = [];
                lastEol = undefined;
                edits = mergeSort(edits, function (a, b) {
                  if (a.range && b.range) {
                    return Range.compareRangesUsingStarts(a.range, b.range);
                  } // eol only changes should go to the end


                  var aRng = a.range ? 0 : 1;
                  var bRng = b.range ? 0 : 1;
                  return aRng - bRng;
                });
                _iterator2 = _createForOfIteratorHelper(edits);
                _context3.prev = 7;

                _iterator2.s();

              case 9:
                if ((_step2 = _iterator2.n()).done) {
                  _context3.next = 27;
                  break;
                }

                _step2$value = _step2.value, range = _step2$value.range, text = _step2$value.text, eol = _step2$value.eol;

                if (typeof eol === 'number') {
                  lastEol = eol;
                }

                if (!(Range.isEmpty(range) && !text)) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("continue", 25);

              case 14:
                original = model.getValueInRange(range);
                text = text.replace(/\r\n|\n|\r/g, model.eol);

                if (!(original === text)) {
                  _context3.next = 18;
                  break;
                }

                return _context3.abrupt("continue", 25);

              case 18:
                if (!(Math.max(text.length, original.length) > EditorSimpleWorker._diffLimit)) {
                  _context3.next = 21;
                  break;
                }

                result.push({
                  range: range,
                  text: text
                });
                return _context3.abrupt("continue", 25);

              case 21:
                // compute diff between original and edit.text
                changes = stringDiff(original, text, false);
                editOffset = model.offsetAt(Range.lift(range).getStartPosition());
                _iterator3 = _createForOfIteratorHelper(changes);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    change = _step3.value;
                    start = model.positionAt(editOffset + change.originalStart);
                    end = model.positionAt(editOffset + change.originalStart + change.originalLength);
                    newEdit = {
                      text: text.substr(change.modifiedStart, change.modifiedLength),
                      range: {
                        startLineNumber: start.lineNumber,
                        startColumn: start.column,
                        endLineNumber: end.lineNumber,
                        endColumn: end.column
                      }
                    };

                    if (model.getValueInRange(newEdit.range) !== newEdit.text) {
                      result.push(newEdit);
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

              case 25:
                _context3.next = 9;
                break;

              case 27:
                _context3.next = 32;
                break;

              case 29:
                _context3.prev = 29;
                _context3.t0 = _context3["catch"](7);

                _iterator2.e(_context3.t0);

              case 32:
                _context3.prev = 32;

                _iterator2.f();

                return _context3.finish(32);

              case 35:
                if (typeof lastEol === 'number') {
                  result.push({
                    eol: lastEol,
                    text: '',
                    range: {
                      startLineNumber: 0,
                      startColumn: 0,
                      endLineNumber: 0,
                      endColumn: 0
                    }
                  });
                }

                return _context3.abrupt("return", result);

              case 37:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 29, 32, 35]]);
      }));
    } // ---- END minimal edits ---------------------------------------------------------------

  }, {
    key: "computeLinks",
    value: function computeLinks(modelUrl) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var model;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                model = this._getModel(modelUrl);

                if (model) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", null);

              case 3:
                return _context4.abrupt("return", _computeLinks(model));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "textualSuggest",
    value: function textualSuggest(modelUrl, position, wordDef, wordDefFlags) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var model, words, seen, wordDefRegExp, wordAt, _iterator4, _step4, word;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                model = this._getModel(modelUrl);

                if (model) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", null);

              case 3:
                words = [];
                seen = new Set();
                wordDefRegExp = new RegExp(wordDef, wordDefFlags);
                wordAt = model.getWordAtPosition(position, wordDefRegExp);

                if (wordAt) {
                  seen.add(model.getValueInRange(wordAt));
                }

                _iterator4 = _createForOfIteratorHelper(model.words(wordDefRegExp));
                _context5.prev = 9;

                _iterator4.s();

              case 11:
                if ((_step4 = _iterator4.n()).done) {
                  _context5.next = 23;
                  break;
                }

                word = _step4.value;

                if (!seen.has(word)) {
                  _context5.next = 15;
                  break;
                }

                return _context5.abrupt("continue", 21);

              case 15:
                seen.add(word);

                if (isNaN(Number(word))) {
                  _context5.next = 18;
                  break;
                }

                return _context5.abrupt("continue", 21);

              case 18:
                words.push(word);

                if (!(seen.size > EditorSimpleWorker._suggestionsLimit)) {
                  _context5.next = 21;
                  break;
                }

                return _context5.abrupt("break", 23);

              case 21:
                _context5.next = 11;
                break;

              case 23:
                _context5.next = 28;
                break;

              case 25:
                _context5.prev = 25;
                _context5.t0 = _context5["catch"](9);

                _iterator4.e(_context5.t0);

              case 28:
                _context5.prev = 28;

                _iterator4.f();

                return _context5.finish(28);

              case 31:
                return _context5.abrupt("return", words);

              case 32:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[9, 25, 28, 31]]);
      }));
    } // ---- END suggest --------------------------------------------------------------------------
    //#region -- word ranges --

  }, {
    key: "computeWordRanges",
    value: function computeWordRanges(modelUrl, range, wordDef, wordDefFlags) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var model, wordDefRegExp, result, line, words, _iterator5, _step5, word, array;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                model = this._getModel(modelUrl);

                if (model) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", Object.create(null));

              case 3:
                wordDefRegExp = new RegExp(wordDef, wordDefFlags);
                result = Object.create(null);
                line = range.startLineNumber;

              case 6:
                if (!(line < range.endLineNumber)) {
                  _context6.next = 31;
                  break;
                }

                words = model.getLineWords(line, wordDefRegExp);
                _iterator5 = _createForOfIteratorHelper(words);
                _context6.prev = 9;

                _iterator5.s();

              case 11:
                if ((_step5 = _iterator5.n()).done) {
                  _context6.next = 20;
                  break;
                }

                word = _step5.value;

                if (isNaN(Number(word.word))) {
                  _context6.next = 15;
                  break;
                }

                return _context6.abrupt("continue", 18);

              case 15:
                array = result[word.word];

                if (!array) {
                  array = [];
                  result[word.word] = array;
                }

                array.push({
                  startLineNumber: line,
                  startColumn: word.startColumn,
                  endLineNumber: line,
                  endColumn: word.endColumn
                });

              case 18:
                _context6.next = 11;
                break;

              case 20:
                _context6.next = 25;
                break;

              case 22:
                _context6.prev = 22;
                _context6.t0 = _context6["catch"](9);

                _iterator5.e(_context6.t0);

              case 25:
                _context6.prev = 25;

                _iterator5.f();

                return _context6.finish(25);

              case 28:
                line++;
                _context6.next = 6;
                break;

              case 31:
                return _context6.abrupt("return", result);

              case 32:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[9, 22, 25, 28]]);
      }));
    } //#endregion

  }, {
    key: "navigateValueSet",
    value: function navigateValueSet(modelUrl, range, up, wordDef, wordDefFlags) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var model, wordDefRegExp, selectionText, wordRange, word, result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                model = this._getModel(modelUrl);

                if (model) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return", null);

              case 3:
                wordDefRegExp = new RegExp(wordDef, wordDefFlags);

                if (range.startColumn === range.endColumn) {
                  range = {
                    startLineNumber: range.startLineNumber,
                    startColumn: range.startColumn,
                    endLineNumber: range.endLineNumber,
                    endColumn: range.endColumn + 1
                  };
                }

                selectionText = model.getValueInRange(range);
                wordRange = model.getWordAtPosition({
                  lineNumber: range.startLineNumber,
                  column: range.startColumn
                }, wordDefRegExp);

                if (wordRange) {
                  _context7.next = 9;
                  break;
                }

                return _context7.abrupt("return", null);

              case 9:
                word = model.getValueInRange(wordRange);
                result = BasicInplaceReplace.INSTANCE.navigateValueSet(range, selectionText, wordRange, word, up);
                return _context7.abrupt("return", result);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    } // ---- BEGIN foreign module support --------------------------------------------------------------------------

  }, {
    key: "loadForeignModule",
    value: function loadForeignModule(moduleId, createData, foreignHostMethods) {
      var _this2 = this;

      var proxyMethodRequest = function proxyMethodRequest(method, args) {
        return _this2._host.fhr(method, args);
      };

      var foreignHost = types.createProxyObject(foreignHostMethods, proxyMethodRequest);
      var ctx = {
        host: foreignHost,
        getMirrorModels: function getMirrorModels() {
          return _this2._getModels();
        }
      };

      if (this._foreignModuleFactory) {
        this._foreignModule = this._foreignModuleFactory(ctx, createData); // static foreing module

        return Promise.resolve(types.getAllMethodNames(this._foreignModule));
      } // ESM-comment-begin
      // 		return new Promise<any>((resolve, reject) => {
      // 			require([moduleId], (foreignModule: { create: IForeignModuleFactory }) => {
      // 				this._foreignModule = foreignModule.create(ctx, createData);
      // 
      // 				resolve(types.getAllMethodNames(this._foreignModule));
      // 
      // 			}, reject);
      // 		});
      // ESM-comment-end
      // ESM-uncomment-begin


      return Promise.reject(new Error("Unexpected usage")); // ESM-uncomment-end
    } // foreign method request

  }, {
    key: "fmr",
    value: function fmr(method, args) {
      if (!this._foreignModule || typeof this._foreignModule[method] !== 'function') {
        return Promise.reject(new Error('Missing requestHandler or method: ' + method));
      }

      try {
        return Promise.resolve(this._foreignModule[method].apply(this._foreignModule, args));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }]);

  return EditorSimpleWorker;
}(); // ---- END diff --------------------------------------------------------------------------
// ---- BEGIN minimal edits ---------------------------------------------------------------

EditorSimpleWorker._diffLimit = 100000; // ---- BEGIN suggest --------------------------------------------------------------------------

EditorSimpleWorker._suggestionsLimit = 10000;
/**
 * Called on the worker side
 * @internal
 */

export function create(host) {
  return new EditorSimpleWorker(host, null);
}

if (typeof importScripts === 'function') {
  // Running in a web worker
  globals.monaco = createMonacoBaseAPI();
}